<template>
    <div class="w-100">
        <div class="d-flex flex-wrap border-bottom w-100">

            <div class="py-1 px-3 tab-div" :class="viewModel.browseTab ? activeClasses : inActiveClasses">
                <a href="javascript:void(0)" @click="viewModel.browseTab = true">Browse</a>
            </div>
            <div class="py-1 px-3 tab-div" :class="!viewModel.browseTab ? activeClasses : inActiveClasses">
                <a href="javascript:void(0)" @click="viewModel.browseTab = false">Edit</a>
            </div>

        </div>

        <theme-browser v-if="viewModel.browseTab" :view-model="viewModel" :current-theme-id="currentThemeId"
                       @newThemeEvent="onCreateNewTheme" @editThemeEvent="onEditTheme" @copyThemeEvent="onCopyTheme">
        </theme-browser>

        <div v-else class="d-flex">
            <theme-sidebar :theme="viewModel.theme"></theme-sidebar>
            <example-theme-content :theme="viewModel.theme"></example-theme-content>
        </div>
    </div>
</template>

<script>
import ThemeLoader from "../utils/ThemeLoader";
import ThemeBrowser from "./ThemeBrowser.vue";
import ThemeSidebar from "./ThemeSidebar.vue";
import ExampleThemeContent from "./ExampleThemeContent.vue";

export default {
    name: 'ThemeContainer',
    components: {ExampleThemeContent, ThemeSidebar, ThemeBrowser},
    props: ['viewModel', 'currentThemeId'],
    data () {
        return {
            model: webase.model,
        }
    },
    computed: {
        activeClasses() {
            return "border active-tab rounded-top"
        },
        inActiveClasses() {
            return "border-bottom"
        },
    },
    mounted () {
    },
    methods: {
        onCreateNewTheme() {
            console.log('onCreateNewTheme in theme container')
            this.$emit('newThemeEvent'); // bubble up the event!

            // TODO: we need to do much better

            // let newTheme = webase.utils.theme.defaultTheme()
            // this.viewModel.theme = {...newTheme}
            // this.browseTab = false
            // webase.utils.font.loadThemeFonts(newTheme)
            // ThemeLoader.previewTheme(this.viewModel.theme)
        },
        onEditTheme() {
            this.browseTab = false
        },
        onCopyTheme() {
            let copiedTheme = {...this.viewModel.theme}
            copiedTheme.id = null
            copiedTheme.user_id = null
            copiedTheme.name = 'Copy of ' + copiedTheme.name
            this.viewModel.theme = copiedTheme
            this.browseTab = false
            ThemeLoader.previewTheme(this.viewModel.theme)
        },
    }
}
</script>

<style>

</style>
